import React, { useMemo, useRef, useState } from "react";

import { ButtonV4, ModalV4 } from "../common/ui";

import { formatGroupRows, formatGroupRowsFromSheet, type GroupRow } from "./registrationModelV4";

type ModalGroupRegisterV4Props = {
  /** ผลเปิดประวัติหมู่จาก BE (แทนแถวจากไฟล์เมื่อมีค่า) */
  emergencyList?: Partial<GroupRow>[] | null;
  saving: boolean;
  onClearList: () => void;
  onRegister: (rows: GroupRow[]) => void;
  onClose: () => void;
};

/** เปิดประวัติหมู่จากไฟล์ .xlsx */
const ModalGroupRegisterV4 = (props: ModalGroupRegisterV4Props) => {
  const [groupFile, setGroupFile] = useState<GroupRow[]>([]);

  const fileRef = useRef<HTMLInputElement>(null);

  // Memo
  const groupRows = useMemo(
    () => (props.emergencyList?.length ? formatGroupRows(props.emergencyList) : groupFile),
    [props.emergencyList, groupFile],
  );

  // Handler
  const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = async (event) => {
      const XLSX = await import("xlsx");
      const workbook = XLSX.read(event.target?.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      props.onClearList();

      setGroupFile(formatGroupRowsFromSheet(XLSX.utils.sheet_to_json(sheet)));
    };

    reader.readAsBinaryString(file);

    e.target.value = "";
  };

  const handleUpload = () => {
    fileRef.current?.click();
  };

  const handleRegister = () => {
    props.onRegister(groupFile);
  };

  // Render
  return (
    <ModalV4 title="เปิดประวัติหมู่" width={760} onClose={props.onClose}>
      <div className="hv4-reg-modal-body">
        <input ref={fileRef} type="file" accept=".xlsx" hidden onChange={handleChangeFile} />
        <div className="hv4-reg-group">
          <table>
            <thead>
              <tr>
                <th>No.</th>
                <th>HN</th>
                <th>คำนำหน้า</th>
                <th>ชื่อ</th>
                <th>สกุล</th>
                <th>เพศ</th>
              </tr>
            </thead>
            <tbody>
              {groupRows.map((row) => (
                <tr key={row.no}>
                  <td>{row.no}</td>
                  <td>{row.hn}</td>
                  <td>{row.pre_name}</td>
                  <td>{row.first_name_th}</td>
                  <td>{row.last_name_th}</td>
                  <td>{row.gender}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="hv4-reg-modal-foot">
        <ButtonV4 variant="primary" onClick={handleUpload}>
          อัพโหลดไฟล์
        </ButtonV4>
        <ButtonV4
          variant="ok"
          disabled={groupFile.length === 0 || props.saving}
          onClick={handleRegister}
        >
          ยืนยันเปิดประวัติ
        </ButtonV4>
      </div>
    </ModalV4>
  );
};

ModalGroupRegisterV4.displayName = "ModalGroupRegisterV4";

export default ModalGroupRegisterV4;
